import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Text } from "sprout-ui-primitives";
import slugify from "sprout-lib/dist/slugify";
const fallback = (topic)=>topic ? /*#__PURE__*/ _jsx(Link, {
        to: `/${topic.rootTopicOrSelf.owner.username}/${topic.id}-${slugify(topic.title)}`,
        children: topic.title
    }) : "a deleted tree";
const StyledText = styled(Text)`
  a:hover {
    text-decoration: underline;
  }
`;
function From(props) {
    const { oldTopic , newTopic  } = props;
    return /*#__PURE__*/ _jsxs(StyledText, {
        fontSize: 0,
        lineHeight: "16px",
        children: [
            "from ",
            fallback(oldTopic),
            " to ",
            fallback(newTopic)
        ]
    });
}
From.propTypes = {
    oldTopic: PropTypes.shape({
        nodeId: PropTypes.string.isRequired
    }),
    newTopic: PropTypes.shape({
        nodeId: PropTypes.string.isRequired
    })
};
export default From;
